import React, { useEffect, useRef } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import Navbar from "../../Navbar/Navbar.js";
import AppDev from "../../../Images/Application-development.svg";
import Footer from "../../Footer/Footer.js";
import  { ThreeColumnContainer } from "./DetailsCard.js";
import logoTextData from "../../../resources/logoTextData.json";
import imageHeader from "../../../resources/imageHeader.json";
import SubHeadings from "./SubHeadings.js";
import { ReactComponent as Code } from "feather-icons/dist/icons/code.svg";
import { ReactComponent as Monitor } from "feather-icons/dist/icons/monitor.svg";
import { ReactComponent as Settings } from "feather-icons/dist/icons/settings.svg";
import { ReactComponent as BarChart } from "feather-icons/dist/icons/bar-chart.svg";
import { ReactComponent as Tool } from "feather-icons/dist/icons/tool.svg";
import Header, {
  NavLink,
  NavLinks,
  LogoLink,
  NavToggle,
  DesktopNavLinks,
} from "../../Navbar/Navbar.js";
import { useNavigate } from "react-router-dom";
import BreadCrumbs from "./BreadCrumbs.js";
import ContactUsButton from "./ContactUsButton.js";
import IconCard from "./IconCard.js";
import TechStack1 from "./TechStack1.js";
import ImageHeaderMain from "./ImageHeaderMain.js";

const Container = tw.div`relative  bg-center 
bg-no-repeat
h-screen
w-full  `;
const StyledHeader = styled(Header)`
  ${tw`pt-8 max-w-none text-gray-800 bg-white z-10`}
  ${DesktopNavLinks} ${NavLink}, ${LogoLink} {
    ${tw`text-gray-100 hover:border-gray-300 hover:text-gray-300`}
  }
  ${NavToggle}.closed {
    ${tw`text-gray-100 hover:text-primary-500`}
  }
`;
const OpacityOverlay = tw.div`z-10 absolute inset-0 bg-pink-700 opacity-25`;
const HeroContainer = tw.div`z-20 relative px-4 sm:px-8 max-w-screen-2xl mx-auto`;
const ContainerNav = styled.div`
  ${tw`relative`}
`;
const Wrapper = tw.div`max-w-screen-xl mx-auto py-2  mb-20`;
const imgStyle={width:"40px",height:"40px"}

let data = [
  {
    imageSrc: <Settings style={imgStyle}/>,
  },
  {
    imageSrc: <Monitor style={imgStyle}/>,
  },
  {
    imageSrc: <Code style={imgStyle}/>,
  },
  {
    imageSrc: <BarChart />,
  },
  {
    imageSrc: <Tool />,
  }
];
const ourservices = logoTextData.AppDevelopment.ourservices.map((item, index) => (
  <IconCard
    key={index}
    title={item.title}
    description={item.description}
    imageSrc={data[index].imageSrc}
  />
));

const ApplicationDevelopment = () => {

  useEffect(()=>{
    document.title="Welcome to Iqura - Application Development"
    let descMeta=document.querySelector("meta[name='description']")
    descMeta.setAttribute("content", 'Iqura  creates scalable and innovative applications that cater to your specific business needs. Our team of skilled developers is dedicated to delivering high-quality, user-friendly applications that enhance your overall digital presence')
    let keyword=document.querySelector("meta[name='keywords']")
    keyword.setAttribute("content", "Application Development, Application maintenance and support, Application modernization")
    const link = document.createElement('link');
    link.rel = 'canonical';
    link.href = 'https://www.iqura.tech/our-services/application-development';
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
    },[]);

    const svgStyle = {
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 320'%3E%3Cpath fill='%23EEF5FF' fill-opacity='0.9' d='M0,96L48,101.3C96,107,192,117,288,122.7C384,128,480,128,576,117.3C672,107,768,85,864,80C960,75,1056,85,1152,117.3C1248,149,1344,203,1392,229.3L1440,256L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z'/%3E%3C/svg%3E")`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      height: "350px",
    };
  
    const navigate = useNavigate();
    const navLinks = [
      <NavLinks key={1}>
        <NavLink onClick={() => navigate("/", { state: "whatwedo" })}>
          What we do
        </NavLink>
        <NavLink onClick={() => navigate("/", { state: "ourservices" })}>
          Services
        </NavLink>
        <NavLink onClick={() => navigate("/", { state: "techstack" })}>
          Techstack
        </NavLink>
        <NavLink onClick={() => navigate("/", { state: "whoweare" })}>
          Who we are
        </NavLink>
        <NavLink onClick={() => navigate("/", { state: "career" })}>
          Careers
        </NavLink>
        <NavLink onClick={() => navigate("/", { state: "contact" })}>
          Contact
        </NavLink>
      </NavLinks>,
    ];
    const childRef = useRef(null);
    const handleBreadCrumbClose = () => {
      if (childRef.current) {
        childRef.current.handleClick();
      }
    };

  return (
    <>
    <Navbar className="shadow-md" />
    <ContainerNav>
      <OpacityOverlay />
      <HeroContainer>
        <StyledHeader links={navLinks} />
      </HeroContainer>
    </ContainerNav>
    <BreadCrumbs ref={childRef} title={"Application  Development"} title1={"Our services"}  bgcolor={"#EEF5FF"}/>
    <ContactUsButton />
    <Container style={svgStyle} onClick={handleBreadCrumbClose}>
      <ImageHeaderMain
        imageHeaderData={imageHeader.applicationDevelopment}
        imgsource={AppDev}
      />
      <Wrapper>
       <SubHeadings heading1="Our" heading2="Expertise" />
    <ThreeColumnContainer>{ourservices}</ThreeColumnContainer>
    <SubHeadings heading1="Our" heading2="Techstack" />
    <TechStack1/>
    </Wrapper>
      <Footer />
    </Container>
  </>
  )
}

export default ApplicationDevelopment